import React from 'react';

const SpamhausEDROPAdapterSummary = () => {
  return (<dl>
    <i>No configuration required.</i>
  </dl>);
};

export default SpamhausEDROPAdapterSummary;



// WEBPACK FOOTER //
// ./src/web/components/adapters/spamhaus-edrop/SpamhausEDROPAdapterSummary.jsx